export enum TicketSellerPaymentType {
  EVENTPAGE_STRIPE = 'EVENTPAGE_STRIPE',
  STRIPE_CONNECT = 'STRIPE_CONNECT',
}
